import { holidayApi } from '../apis/holidayApi';
import { userAuthApi } from '../apis/authApi';
import { leaveTypeApi } from '../apis/LeaveType';
import { leaveRequestApi } from '../apis/LeaveRequest';
import { departMentApi } from '../apis/department';
import { employeeApi } from '../apis/employee';
import { designationApi } from '../apis/Designation';
import { leaveBalanceApi } from '../apis/LeaveBalance';
import { attendanceApi } from '../apis/attendanceApi';
import { filesApi } from '../apis/files';
import { payrollApi } from '../apis/payrollApi';
import { timeTrackingApi } from '../apis/timeTrackingApi';
import { supportTicketApi } from '../apis/SupportTicketApi';
import { assetsApi } from '../apis/AssetsApi';
import { assetFieldsApi } from '../apis/AssetFieldsApi';
import { dashboardApi } from '../apis/Dashboard';
import { calendarApi } from '../apis/CalendarApi';
import { kpiApi } from '../apis/KPIApi';
import { performanceApi } from '../apis/PerformanceApi';
import { notificationApi } from '../apis/Notification';
import { lopAndOvertimeRequestApi } from '../apis/LOPAndOvertimeAPI';
import { complainApi } from '../apis/ComplainApi';
import { systemRoleApi } from '../apis/systemRoleApi';
import { hrxModuleApi } from '../apis/HrxModuleApi';
import { googleCalendarApi } from '../apis/googleCalendarApi';
import { attendanceViolationApi } from '../apis/attendanceViolationApi';

const apiSlices = [
  holidayApi,
  userAuthApi,
  leaveTypeApi,
  leaveRequestApi,
  departMentApi,
  employeeApi,
  designationApi,
  leaveBalanceApi,
  attendanceApi,
  filesApi,
  payrollApi,
  timeTrackingApi,
  supportTicketApi,
  assetsApi,
  assetFieldsApi,
  dashboardApi,
  calendarApi,
  kpiApi,
  performanceApi,
  notificationApi,
  lopAndOvertimeRequestApi,
  complainApi,
  systemRoleApi,
  hrxModuleApi,
  googleCalendarApi,
  attendanceViolationApi
];

export const resetAllApiCaches = (dispatch) => {
  apiSlices.forEach((api) => dispatch(api.util.resetApiState()));
};
